import React from 'react';
import { IBannerPrincipalProps, IBannerSlider } from './BannerSlider.interface';
import { Banner } from './Banner';

import styles from './BannerSlider.module.scss';
import { Box } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';

import 'swiper/css';
import 'swiper/css/pagination';
import "swiper/css/navigation";

export const BannerSlider = ({ noticias }: IBannerPrincipalProps) => {
	if (noticias === null || noticias === undefined || noticias.length === 0) return null
	const renderBanner = (banner: IBannerSlider) => {
		return (
			<SwiperSlide key={banner.key} >
				<Banner banner={banner} />
			</SwiperSlide>
		);
	};

	return (

		<Box>
			{
				noticias &&
				<Swiper
					modules={[Pagination, Navigation]}
					className={styles.mySwiper}
					slidesPerView={1.1}
					pagination={{ clickable: true }}
					spaceBetween={8}
					navigation={true}
					breakpoints={{
						768: {
							spaceBetween: 0,
							slidesPerView: 1,
						},
					}}
				>
					{noticias.map(renderBanner)}
				</Swiper >
			}
		</Box>
	);
};